import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ProductUsedIn } from '../ProductUsedIn'

@InputType()
export class GetProductUsedInArgs extends ActionArgs {
  @Field(() => ID)
  productId: string
}

export interface IGetProductUsedIn extends IAction<ProductUsedIn[], GetProductUsedInArgs> {}
